import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table } from 'antd';

import type { ColumnsType } from 'antd/es/table';

import { getInternalRemarksByApplicationIDThunk } from '../../services/applicationService/applicationThunk';
import { displayDateAndTime } from '../../utils/datetime.util';
import { AppDispatch, RootState } from '../../store/store';

import './index.less';

interface InternalRemarkTableProps {
  applicationData?: any;
  internalRemarksData?: any;
}

const InternalRemarkTable = ({
  applicationData,
  internalRemarksData,
}: InternalRemarkTableProps) => {
  const dispatch = useDispatch<AppDispatch>();

  const { applicationDetails, internalRemarks } = useSelector(
    (state: RootState) => state.application
  );

  // Use props if available, otherwise fall back to Redux state
  const currentApplicationData = applicationData || applicationDetails?.data;
  const currentInternalRemarks = internalRemarksData || internalRemarks;

  const columns: ColumnsType<any> = [
    {
      title: 'Date & Time',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: '10rem',
      render: (text) => (text ? displayDateAndTime(text) : '-'),
    },
    {
      title: 'Description',
      dataIndex: 'remarks',
      key: 'remarks',
    },
    {
      title: 'Created By',
      dataIndex: 'username',
      key: 'username',
      render: (text) => text ?? '-',
    },
  ];

  useEffect(() => {
    // Only run Redux dispatches if we're not using props (i.e., we're in the main page)
    if (!applicationData && !internalRemarksData && currentApplicationData?.id) {
      dispatch(
        getInternalRemarksByApplicationIDThunk({
          filters: { applicationId: currentApplicationData?.id },
        })
      );
    }
  }, [currentApplicationData?.id, applicationData, internalRemarksData]);

  return (
    <Table
      rowKey="id"
      className="min-w-fit"
      dataSource={currentInternalRemarks?.data}
      columns={columns}
      bordered={true}
    />
  );
};

export default InternalRemarkTable;
